/* -------------------------------------------------- */
/*                     Breakpoints                    */
/* -------------------------------------------------- */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const breakpoints: any = {
  '@initial': 'mobile',
  '@micro': 'micro',
  '@sm': 'small',
  '@md': 'medium',
  '@lg': 'large',
}
